import { SkapaElement } from "@ingka/skapa-webc-element";
const styles = ':host{display:inline-block;font-size:.75rem}:host([label]:not([label=""])):before{color:rgb(var(--colour-text-and-icon-2,72,72,72));content:attr(label);display:block;line-height:1.5;margin-bottom:.5rem}:host([value]:not([value=""])):after,slot{background-color:rgb(var(--colour-neutral-7,17,17,17));border:1px solid rgb(var(--colour-neutral-7,17,17,17));color:rgb(var(--colour-text-and-icon-5,255,255,255));content:attr(value);display:inline-block;font-weight:700;line-height:1.25;padding:calc(.25rem - 1px) calc(.75rem - 1px)}@media print{:host([value]:not([value=""])):after,slot{background-color:initial;border-color:rgb(var(--colour-static-black,17,17,17));color:rgb(var(--colour-static-black,17,17,17))}@supports (print-color-adjust:exact) or (-webkit-print-color-adjust:exact){:host([value]:not([value=""])):after,slot{background-color:rgb(var(--colour-static-black,17,17,17));color:rgb(var(--colour-static-white,255,255,255));-webkit-print-color-adjust:exact;print-color-adjust:exact}}}:host([subtle]) slot,:host([subtle][value]:not([value=""])):after{background-color:rgb(var(--colour-neutral-2,245,245,245));border-color:rgb(var(--colour-neutral-2,245,245,245));color:rgb(var(--colour-text-and-icon-1,17,17,17))}:host([value]:not([value=""])) slot{display:none}';
function generateTemplate({ html }) {
  const template = document.createElement("template");
  template.innerHTML = html`
    <style>
      ${styles}
    </style>
    <slot></slot>
  `;
  return { main: template };
}
class ProductIdentifier extends SkapaElement {
  constructor() {
    super();
    this.gatherProperties(["label", "value", "subtle"], this);
    const shadow = this.attachShadow({ mode: "open" });
    const template = this.getTemplates(generateTemplate);
    shadow.appendChild(template.main.content.cloneNode(true));
  }
  get label() {
    return this.getAttribute("label");
  }
  set label(label) {
    if (label) this.setAttribute("label", label);
    else this.removeAttribute("label");
  }
  get value() {
    return this.getAttribute("value");
  }
  set value(value) {
    if (value) this.setAttribute("value", value);
    else this.removeAttribute("value");
  }
  get subtle() {
    return this.hasAttribute("subtle");
  }
  set subtle(toggle) {
    this.toggleAttribute("subtle", !!toggle);
  }
}
ProductIdentifier.skapaTagName = "product-identifier";
ProductIdentifier.skapaDependencies = [];
var ProductIdentifier_default = ProductIdentifier;
export {
  ProductIdentifier,
  ProductIdentifier_default as default
};
